<template>
  <div>
    <h3>Choix du poste</h3>
    <VeeForm :validation-schema="schema" @submit="onSubmit">
      <div class="mb-3">
        <label for="poste" class="form-label">Poste souhaité :</label>
        <Field name="poste" as="select" class="form-select" v-model="localFormData.poste">
          <option value="">Sélectionnez un poste</option>
          <option v-for="offre in offresDisponibles" 
                  :key="offre.id" 
                  :value="offre.id">
            {{ offre.title }}
          </option>
        </Field>
        <ErrorMessage name="poste" class="text-danger" />
        
        <!-- Afficher les détails de l'offre sélectionnée -->
        <div v-if="offreSelectionnee" class="mt-3 offer-details">
          <h4>Détails du poste</h4>
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">{{ offreSelectionnee.title }}</h5>
              <p class="card-text">{{ offreSelectionnee.description }}</p>
              <div class="requirements">
                <h6>Prérequis :</h6>
                <div v-html="offreSelectionnee.requirements"></div>
              </div>
              <div class="deadline">
                <strong>Date limite :</strong> 
                {{ formatDate(offreSelectionnee.deadline) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label for="pretention" class="form-label">Prétention salariale (FCFA) :</label>
        <Field name="pretention" type="number" class="form-control" v-model="localFormData.pretention" />
        <ErrorMessage name="pretention" class="text-danger" />
      </div>

      <button type="button" class="btn btn-secondary me-2" @click="$emit('prev')">Précédent</button>
      <button type="submit" class="btn btn-primary" :disabled="!isValidSelection">Suivant</button>
    </VeeForm>
  </div>
</template>

<script>
import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate'
import { defineRule } from 'vee-validate'
import { required } from '@vee-validate/rules'

defineRule('required', required)

export default {
  name: 'ChoixPoste',
  components: {
    VeeForm,
    Field,
    ErrorMessage
  },
  props: ['formData'],
  emits: ['update:formData', 'next', 'prev'],
  
  data() {
    return {
      localFormData: { ...this.formData },
      offresDisponibles: [],
      schema: {
        poste: 'required',
        pretention: 'required'
      }
    }
  },

  computed: {
    offreSelectionnee() {
      return this.offresDisponibles.find(offre => offre.id === this.localFormData.poste)
    },
    
    isValidSelection() {
      return this.localFormData.poste && this.localFormData.pretention
    }
  },

  async created() {
    await this.loadOffresDisponibles()
  },

  methods: {
    async loadOffresDisponibles() {
      try {
        const response = await this.$http.get('/jobs')
        this.offresDisponibles = response.data.job_offers.data.filter(offre => 
          offre.is_active && !this.isExpired(offre.deadline)
        )
      } catch (error) {
        console.error('Erreur lors du chargement des offres:', error)
        // Afficher un message d'erreur à l'utilisateur
      }
    },

    isExpired(deadline) {
      return new Date(deadline) < new Date()
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },

    onSubmit() {
      if (this.isValidSelection) {
        // Ajouter les informations de l'offre sélectionnée
        this.$emit('update:formData', {
          ...this.localFormData,
          offreDetails: {
            id: this.offreSelectionnee.id,
            title: this.offreSelectionnee.title,
            deadline: this.offreSelectionnee.deadline
          }
        })
        this.$emit('next')
      }
    }
  }
}
</script>

<style scoped>
.offer-details {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-top: 20px;
}

.requirements {
  margin: 15px 0;
}

.deadline {
  color: #dc3545;
  margin-top: 10px;
}

.card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.card-body {
  padding: 20px;
}

.card-title {
  color: #0066b6;
  margin-bottom: 15px;
}
</style> 